import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  toastr.success(response.data.msg);
  swal({
      title: context.$t('swal_popup.deleted'),
      text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>'+ context.$t('swal_popup.template_deleted') +'</div>',
      type: "warning",
      showCancelButton: false,
      confirmButtonClass: "btn-warning",
      confirmButtonText: context.$t('button.ok'),
      closeOnConfirm: true,
      html: true
    },
    function() {
      $(".confirm").addClass("disabled");
      $(".pulseWarning").hide();
    });
  $('#redact').html("");
  context.loading = false;
  context.get_autoactions();
  Vue.router.push({
    name: 'automation.index',
  });
};

// When the request fails
const failed = (error, context) => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  context.showToasterError(error);
  context.loading = false;
};

export default (context, autoactioId) => Vue.$http.delete(`/actions/${autoactioId}`)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      } else {
        failed();
      }
    })
    .catch((error) => {
      failed(error, context);
    });



// WEBPACK FOOTER //
// ./src/app/services/automation/destroy.js